<template>
  <div class="page-rankdetail cont-fensi common-wrap">
    <div class="user-much-num">
      <span class="active">影响力明细</span> |
      <router-link tag="span"  :to="{ path: '/ranking', query: { userId: userId } }" >排行榜</router-link>
    </div>
    <div class="list-detail">
      <div class="item" v-for="(item, index) in tableData"
           :key="index">
        <div class="date"> {{ item.logDateStr}}</div>
        <table class="item-table">
          <tr  v-for="(log, i) in item.logs" :key="i">
            <td>{{log.indicatorName}}</td>
            <td>奖励<i>{{log.influenceValue}}</i></td>
          </tr>
          <tr>
            <td>总计</td>
            <td>奖励<i> {{ item.totalVal}}</i></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="pagintion-f">
      <el-pagination
              background
              @current-change="search"
              layout="prev, pager, next"
              :current-page="pageIndex"
              :page-size="pageSize"
              :hide-on-single-page="true"
              :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios';
  import vue from 'vue';

  import { mapState } from "vuex";
  import updateTdk from "@/utils/tdk";

  vue.prototype.$axios = axios;
export default {
  components: {

  },
  data () {
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      tableData: [],
      total: 0,
      userId:0,
      pageIndex: 1,
      pageSize: 5,
    }
  },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },
  mounted() {
    this.isMounted = true;

    let userId=this.$route.query.userId;
    this.userId=userId;

    const alreadyIncremented = !!this.productionDetail;
    if (!alreadyIncremented) {
      this.fetchData().then(this.initData());
    } else {
      this.initData();
    }
  },
  methods:{
    fetchData(){
      return this.$store
              .dispatch("FETCH_USER_DETAIL", {
                id:this.$route.query.userId
              })
              .finally(() => {
                this.$loading(false);
                console.log("this.userDetail =====  ",this.userDetail)
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initData(){
      this.search(1)
    },
    search(page){
      let _this = this
      _this.pageIndex = page;
      _this.fullscreenLoading = true;
      let url = '/rrbi/influence/record?userId=' + _this.userId + '&pageIndex=' + _this.pageIndex + '&pageSize=' + _this.pageSize + "&ti=" + new Date().getMilliseconds();
      _this.$axios.get(url).then(function (result) {
        console.log(result)
        _this.tableData = result.data.response.list
        _this.total = result.data.response.total
        _this.fullscreenLoading = false
      })
    },
    setSeo(){
      this.headTitle = this.userDetail.userName+"的影响力——人人动画网【官网】";
      //this.headKeywords = this.activityInfoDetail.showProType;
      this.headDesc =this.userDetail.userName+"的影响力";
    }
  }
}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";
.user-much-num{
  span{
    margin: 0 5px;
    cursor: pointer;
    &:first-child{
      margin-left: 0;
    }
    &.active{
      font-weight: bold;
    }
  }
}
.page-rankdetail{
  .select-tit{
    padding: 13px 0;
    line-height: 24px;
    li{
      float: left;
      margin-right: 30px;
      color: #a3a3a3;
      cursor: pointer;
      &.active{
        color: #4c4c4c;
      }
    }
  }
  .list-detail{
    margin-bottom: 20px;
    padding: 20px 50px;
    background: #fff;
    .item{
      margin-bottom: 30px;
      color: #666;
      .date{
        padding: 14px 30px;
        line-height: 22px;
      }
      .item-table{
        width: 100%;
        tr{
          height: 50px;
          td{
            padding: 0 30px;
            text-align: left;
            i{
              margin-left: 4px;
              font-style: normal;
              color: #ec4b5a;
            }
          }
          &:nth-child(odd){
            background: #f7faff;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .page-rankdetail{
    .select-tit{
      padding: 10px;
    }
    .list-detail{
      padding: 10px;
      .item:last-child{
        margin-bottom: 0;
      }
    }
  }
}
</style>
